/**
 * Cosa dire quando il pagamento non parte.
 *
 * Il checkout risponde 400 solo per motivi che riguardano i documenti
 * (spariti dopo circa un'ora, elaborazione non ancora conclusa) e li scrive
 * lui, in italiano: quelli si mostrano come sono. Ogni altro rifiuto parla del
 * pagamento. Prima qualunque 400 diventava "I file selezionati non sono
 * validi", anche quando a rifiutare era Stripe.
 */

export const PAGAMENTO_NON_AVVIATO =
  "Non è stato possibile avviare il pagamento. Riprova fra qualche minuto; se il problema continua, scrivici.";

/** Il motivo scritto dal backend per un 400 del checkout, se c'e'. */
export function motivoCheckout(status, corpo) {
  if (status !== 400) return null;
  const testo = typeof corpo?.detail === "string" ? corpo.detail.trim() : "";
  return testo && testo.length <= 300 ? testo : null;
}
